/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import GaugeChart from 'react-gauge-chart'

import { Spinner } from "react-bootstrap";


export function AdvanceTablesWidget3({ className, queryng, campaign, posv }) {


  if (queryng) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }
  if (!campaign.uid) {
    return (
      <div className={`card card-custom ${className} w-100`}>

      </div>

    )
  }
  return (
    <div className={`card card-custom ${className} w-100 pt-10`}>
      <div className="px-6 row">
        <div className="col-8">
          <h5>

            <span className="text-muted"> Cantidad de tiendas a visitar:</span> <strong> {campaign.pos.length} </strong>

          </h5>
        </div>
        <div className="col-4 text-center" style={{ color: "#7EA6D7", fontWeight: "900" }}>
          <h1>
            <strong>
              ESTADO
            </strong>
          </h1>
          <h1>
            <strong>
              {campaign.state}
            </strong>
          </h1>
        </div>
      </div>
      <GaugeChart id="gauge-chart5"
        nrOfLevels={campaign.pos.length}
        arcsLength={[0.3, 0.4, 0.3]}
        colors={['#7890C4', '#7EA6D8', '#7EB0DE']}
        textColor={"#000"}

        percent={Number(((posv / (campaign.pos.length || 1))).toFixed(3))}
        arcWidth={.35}
        arcPadding={0.02}
      />
      <div className="px-6 row">
        <div className="col-12 text-center">
          <h5>
            <span className="text-muted">Porcentaje de tiendas visitadas ({posv} visitados)</span>
          </h5>
        </div>
      </div>
    </div>
  );
}